import { useQuery } from '@tanstack/react-query';
import { fetchSavedCampaigns } from '../services/outreach/engagementAnalyticsService';
import type { Campaign } from '../types/outreach';

const CAMPAIGNS_QUERY_KEY = ['engagement-campaigns'];

export const useEngagementCampaigns = () => {
  return useQuery<Campaign[], Error>({
    queryKey: CAMPAIGNS_QUERY_KEY,
    queryFn: () => fetchSavedCampaigns(),
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: 2,
    retryDelay: (attempt) => Math.min(4000, 1000 * attempt),
    placeholderData: (previousData) => previousData,
  });
};

export type UseEngagementCampaignsResult = ReturnType<typeof useEngagementCampaigns>;
